// extracted by mini-css-extract-plugin
module.exports = {"form":"followUpParticipantAssistance_form__1bYCO","summary":"followUpParticipantAssistance_summary__2ppPy"};